<template>
    <v-container>
        <v-card outlined>
            <v-card-title class='headline'>Tags:</v-card-title>
            <v-card-actions>
                <v-item-group multiple>
                    
                    <v-item
                        v-for='tag in type.tags'
                        :key='tag'
                    >
                        <v-chip
                            label
                            color='secondary'
                            outlined
                            class='mx-2 my-2'
                        >
                            {{ tag }}
                        </v-chip>
                    </v-item>
                    <v-spacer></v-spacer>
                </v-item-group>
            </v-card-actions>
        </v-card>
        
    </v-container>
</template>

<script>
export default {
    props: {
        type: Object
    }
    
}
</script>